import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';

export class DocumentRawDto {
    communityId: number;
    customerId: string;
    fileId: number;
    categoryCode: string;
    subCategoryCode: string;
    fileTypeCode: string;
    description: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    effectiveDate: Date;

    visibleOnBoardPortal: boolean;
    visibleOnResidentPortal: boolean;
    corporateUseOnly: boolean;
    fileBase64String: string;
    filename: string; // maxLength: 100
}
